import { ReviewSecondaryRating } from "@omni/types/api/reviews/bff/shared/reviewSecondayRating.model";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { formatNumber } from "@/utils/format";

type SecondaryRatingProps = {
    secondaryRating: ReviewSecondaryRating;
};

export const SecondaryRating = ({ secondaryRating }: SecondaryRatingProps) => {
    const { t } = useGranite();

    const displayQualityAverage = formatNumber(
        secondaryRating.quality.value,
        Config.getLocale(),
        {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }
    );

    const displayPriceAverage = formatNumber(
        secondaryRating.quality.value,
        Config.getLocale(),
        {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }
    );

    return (
        <section>
            <p className={cn("tw:mb-0")}>
                {t(
                    "product.reviews.summary.secondaryRating",
                    displayQualityAverage,
                    displayPriceAverage
                )}
            </p>
        </section>
    );
};
